import React, { useState, useEffect } from 'react'
import { connect, useDispatch } from 'react-redux'
import { List, Typography, CircularProgress } from '@material-ui/core'
import EmergencyItem from 'components/atoms/EmergencyItem'
import { fetchEmergencies } from 'store/operations'

const EmergenciesList = ({ emergencies, meta, err, loading, currentUser }) => {
  const dispatch = useDispatch()

  useEffect(() => {
    dispatch(fetchEmergencies({ page: 1, limit: 100, q: null }))
  }, [dispatch])

  const handleOpen = (id) => {
    console.log(id)
  }
  return emergencies && !loading ? (
    <>
      <List>
        {emergencies.map((emergency) => (
          <EmergencyItem
            key={emergency.id}
            emergency={emergency}
            handleOpen={handleOpen}
            currentUser={currentUser}
          />
        ))}
      </List>
    </>
  ) : (
    <div style={{ height: '8rem' }}>
      <CircularProgress />
    </div>
  )
}
// emergencies: resourcesEmergencies.list,
const mapStateToProps = ({ emergencies }) => ({
  emergencies: emergencies.list,
  meta: emergencies?.meta,
  err: emergencies?.err,
  loading: emergencies.loading,
})

export default connect(mapStateToProps)(EmergenciesList)
